import { format } from "date-fns";
import React from "react";
import { notifyError, notifySuccess } from "../../helper";
import client from "../../api";
const Recipient = (props) => {
    const data = props.row;
    const keys = props.dispalyKeys;
    const api = client();
    const getFormatedData = (key,value) => {
        if(key === 'created_at' && value !== ''){
            return format(data.created_at, 'MMM d, yyyy')
        } else if( key === 'latest_sent_at'){
            if(value !== ''){
                return format(data.latest_sent_at, 'MMM d, yyyy hh:mm a')
            } else {
                return "Not Sent"
            }
        } else {
            return value;   
        }
    }

    const updateRecipientsStatusToPlay = async (email) => {
        try{
            const payload = {
                campaign_id:props.campaignID,
                email_list: [email],
                action:"play"
            }
            const response = await api.post('/v1/campaign/contacts/playPause',payload);
            if(response.status === 200 || response.status === 201){
                notifySuccess('Status updated sucessfully.');
                setTimeout(()=>{
                    window.location.reload();
                },1500);
            }

        } catch (error) {
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Unable to change status to play. Please try again.');
            if(error.status === 409) notifyError('Not updated. The status is already active for this recipient');
        }
        
    }
    const updateRecipientsStatusToPause = async (email) => {
        try{
            const payload = {
                campaign_id:props.campaignID,
                email_list: [email],
                action:"pause"
            }
            const response = await api.post('/v1/campaign/contacts/playPause',payload);
            if(response.status === 200 || response.status === 201){
                notifySuccess('Status updated sucessfully.');
                setTimeout(()=>{
                    window.location.reload();
                },1500);
            }
        } catch (error) {
            console.log('error.message',error);
            if(error.status === 400) notifyError('Bad Request. Unable to change status to pause. Please try again.');
            if(error.status === 409) notifyError('Not updated. The status is already paused for this recipient');
        }
    }
    
    return(<tr>
        <td>
            <input type="checkbox" name="select-1" checked={data.isChecked} onChange={()=>{props.handleCheckboxChange(data._id)}} />
        </td>
        <td>
            {data.is_ignore_contact ? <button onClick={()=>updateRecipientsStatusToPlay(data.email)}><i className="bx bx-play"></i></button>:<button onClick={()=>updateRecipientsStatusToPause(data.email)}><i className="bx bx-pause"></i></button>}
        </td>
        {keys.map((key,i)=>(<td key={i}>{getFormatedData(key,data[key])}</td>))}
    </tr>);
}

export default Recipient;